import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Download, X, Smartphone } from 'lucide-react';

export default function InstallBanner() {
    const navigate = useNavigate();
    const [showBanner, setShowBanner] = useState(false);
    const [deviceType, setDeviceType] = useState(null);

    useEffect(() => {
        // Controlla se è già installata come PWA
        const isStandalone = window.matchMedia('(display-mode: standalone)').matches 
            || window.navigator.standalone 
            || document.referrer.includes('android-app://');

        if (isStandalone) {
            return; // Non mostrare se già installata
        }

        // Controlla se l'utente ha già chiuso il banner
        const dismissed = localStorage.getItem('installBannerDismissed');
        if (dismissed) {
            const dismissedTime = parseInt(dismissed);
            // Mostra di nuovo dopo 7 giorni
            if (Date.now() - dismissedTime < 7 * 24 * 60 * 60 * 1000) {
                return;
            }
        }

        // Rileva il tipo di dispositivo
        const userAgent = navigator.userAgent.toLowerCase();
        if (/iphone|ipad|ipod/.test(userAgent)) {
            setDeviceType('ios');
            // Ritardo per mostrare il banner
            setTimeout(() => setShowBanner(true), 2000);
        } else if (/android/.test(userAgent)) {
            setDeviceType('android');
            setTimeout(() => setShowBanner(true), 2000);
        }
    }, []);

    const handleDismiss = () => {
        localStorage.setItem('installBannerDismissed', Date.now().toString());
        setShowBanner(false);
    };

    const handleInstall = () => {
        navigate('/install');
    };

    if (!showBanner) return null;

    return (
        <div className="fixed top-0 left-0 right-0 z-50 animate-slide-down">
            <div className="bg-gradient-to-r from-[#0A0A0A] to-[#111] border-b border-[#00FF41]/30 shadow-[0_4px_20px_rgba(0,255,65,0.15)]">
                <div className="px-4 py-3">
                    <div className="flex items-center gap-3">
                        {/* Icon */}
                        <div className="flex-shrink-0 w-10 h-10 rounded-xl bg-[#00FF41]/20 flex items-center justify-center animate-bounce-slow">
                            <Smartphone className="w-5 h-5 text-[#00FF41]" />
                        </div>
                        
                        {/* Text */}
                        <div className="flex-1 min-w-0">
                            <p className="text-sm font-semibold text-white">
                                Installa Smart Reporting
                            </p>
                            <p className="text-xs text-white/60 truncate">
                                {deviceType === 'ios' 
                                    ? 'Aggiungi alla Home per accesso rapido'
                                    : 'Installa l\'app per accesso rapido'
                                }
                            </p>
                        </div>
                        
                        {/* Actions */}
                        <div className="flex items-center gap-2">
                            <button
                                onClick={handleInstall}
                                className="px-4 py-1.5 bg-[#00FF41] text-black text-sm font-bold rounded-lg hover:bg-[#00FF41]/90 transition-colors flex items-center gap-1"
                            >
                                <Download className="w-4 h-4" />
                                Installa
                            </button>
                            <button
                                onClick={handleDismiss}
                                className="p-1.5 text-white/40 hover:text-white/70 transition-colors"
                                aria-label="Chiudi"
                            >
                                <X className="w-5 h-5" />
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <style>{`
                @keyframes slide-down {
                    from {
                        transform: translateY(-100%);
                        opacity: 0;
                    }
                    to {
                        transform: translateY(0);
                        opacity: 1;
                    }
                }
                
                @keyframes bounce-slow {
                    0%, 100% {
                        transform: translateY(0);
                    }
                    50% {
                        transform: translateY(-3px);
                    }
                }
                
                .animate-slide-down {
                    animation: slide-down 0.3s ease-out;
                }
                
                .animate-bounce-slow {
                    animation: bounce-slow 2s ease-in-out infinite;
                }
            `}</style>
        </div>
    );
}
